import { render, staticRenderFns } from "./deleteActivitiesSignUp.vue?vue&type=template&id=8b658526&scoped=true"
import script from "./deleteActivitiesSignUp.vue?vue&type=script&lang=js"
export * from "./deleteActivitiesSignUp.vue?vue&type=script&lang=js"
import style0 from "./deleteActivitiesSignUp.vue?vue&type=style&index=0&id=8b658526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b658526",
  null
  
)

export default component.exports